import { useState } from "react";
import { Grid, Num, Pick, Result, card, fmt } from "./ui";

const MATERIALS = [["bopp", "BOPP film", 0.91], ["pet", "PET / polyester", 1.39], ["ldpe", "LDPE / PE", 0.92], ["cpp", "CPP", 0.9], ["alu", "Aluminium foil", 2.7],
  ["pvc", "PVC shrink", 1.35], ["paper", "Paper / label stock", 1.0], ["custom", "Custom density", null]];

function Labels({ lengthM }) {
  const [l, setL] = useState({ h: 50, gap: 3, across: 1 });
  const set = (k) => (v) => setL({ ...l, [k]: v });
  const pitch = (Number(l.h) || 0) + (Number(l.gap) || 0);
  const per = pitch ? Math.floor((lengthM * 1000) / pitch) * (Number(l.across) || 1) : 0;
  return (
    <div style={card}>
      <b style={{ fontSize: 13 }}>Labels per roll</b>
      <div style={{ marginTop: 12 }}><Grid>
        <Num testid="reel-label-h" label="Label height (feed direction)" suffix="mm" value={l.h} onChange={set("h")}/>
        <Num testid="reel-label-gap" label="Gap between labels" suffix="mm" value={l.gap} onChange={set("gap")}/>
        <Num testid="reel-label-across" label="Labels across" value={l.across} onChange={set("across")} step={1}/>
        <Result testid="reel-labels-per-roll" big label="Labels per roll" value={fmt(per, 0)}/>
      </Grid></div>
    </div>
  );
}

export function ReelTool() {
  const [mode, setMode] = useState("length");
  const [mat, setMat] = useState("bopp");
  const [r, setR] = useState({ core: 76.2, micron: 20, width: 500, length: 2000, od: 300, kg: 25, density: 1.0 });
  const set = (k) => (v) => setR({ ...r, [k]: v });
  const dens = MATERIALS.find(m => m[0] === mat)[2] ?? (Number(r.density) || 0);
  const t = (Number(r.micron) || 0) / 1000;
  const core = Number(r.core) || 0, width = (Number(r.width) || 0) / 1000;
  const gsm = (Number(r.micron) || 0) * dens;
  let L = 0;
  if (mode === "length") L = (Number(r.length) || 0) * 1000;
  if (mode === "od") L = t ? (Math.PI * (Math.max(0, (Number(r.od) || 0) ** 2 - core ** 2))) / (4 * t) : 0;
  if (mode === "weight") L = gsm && width ? ((Number(r.kg) || 0) * 1000) / (gsm * width) * 1000 : 0;
  const OD = Math.sqrt(core ** 2 + (4 * L * t) / Math.PI);
  const kg = (width * (L / 1000) * gsm) / 1000;
  return (
    <div data-testid="tool-reel" style={{ display: "grid", gap: 16 }}>
      <div style={card}>
        <Grid>
          <Pick testid="reel-mode" label="I know the…" value={mode} onChange={setMode} options={[["length", "Roll length"], ["od", "Outer diameter"], ["weight", "Roll weight"]]}/>
          <Pick testid="reel-material" label="Material" value={mat} onChange={setMat} options={MATERIALS.map(m => [m[0], m[2] ? `${m[1]} (${m[2]} g/cm³)` : m[1]])}/>
          {mat === "custom" && <Num testid="reel-density" label="Density" suffix="g/cm³" value={r.density} onChange={set("density")}/>}
          <Num testid="reel-micron" label="Thickness" suffix="micron" value={r.micron} onChange={set("micron")}/>
          <Num testid="reel-width" label="Reel width" suffix="mm" value={r.width} onChange={set("width")}/>
          <Num testid="reel-core" label="Core diameter" suffix="mm (3 in = 76.2)" value={r.core} onChange={set("core")}/>
          {mode === "length" && <Num testid="reel-length" label="Roll length" suffix="metres" value={r.length} onChange={set("length")}/>}
          {mode === "od" && <Num testid="reel-od" label="Outer diameter" suffix="mm" value={r.od} onChange={set("od")}/>}
          {mode === "weight" && <Num testid="reel-kg" label="Net roll weight" suffix="kg" value={r.kg} onChange={set("kg")}/>}
        </Grid>
      </div>
      <Grid min={160}>
        <Result testid="reel-result-length" big label="Roll length" value={`${fmt(L / 1000, 1)} m`}/>
        <Result testid="reel-result-od" big label="Outer diameter" value={`${fmt(OD, 1)} mm`}/>
        <Result testid="reel-result-weight" big label="Net weight" value={`${fmt(kg, 2)} kg`}/>
        <Result testid="reel-result-gsm" label="Material GSM" value={`${fmt(gsm, 2)} g/m²`}/>
        <Result testid="reel-result-area" label="Area" value={`${fmt(width * (L / 1000), 1)} m²`}/>
        <Result testid="reel-result-od-in" label="Outer diameter" value={`${fmt(OD / 25.4, 2)} in`}/>
      </Grid>
      <Labels lengthM={L / 1000}/>
    </div>
  );
}
